export const logValueNames = {
  SPENT_TIME: 'SPENT_TIME',
  PARAMS: 'PARAMS',
  RESULT: 'RESULT',
};

export const logTypeNames = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  TIME: 'TIME',
  TIME_END: 'TIME_END',
  E_TIME: 'E_TIME',
  E_TIME_END: 'E_TIME_END',
};

export const actionNames = {
  OVERALL_INFO: 'OVERALL_INFO',
  PARALLEL_INFO: 'PARALLEL_INFO',
  EACH_GROUP_INFO: 'ACTION_GROUP_INFO',
  EACH_REQUEST_INFO: 'EACH_REQUEST_INFO',
};
